import { type FORGE_GROUP_GQL_FIELD, ISSUE_FIELD_SINGLE_GROUP_CF_TYPE } from '../constants';

import type { AggTransformerFunction } from '../types';

import { transformAggNodeToLegacyField } from './default-node-transformer';
import { isFieldMissingRenderer } from './helpers';

export const transformAggForgeGroupToLegacyField: AggTransformerFunction<
	typeof FORGE_GROUP_GQL_FIELD
> = (node) => {
	if (isFieldMissingRenderer(node)) {
		return undefined;
	}
	return {
		...transformAggNodeToLegacyField(node),
		value: node.selectedGroup
			? {
					name: node.selectedGroup.name,
				}
			: null,
		autoCompleteUrl: null,
		schema: {
			configuration: null,
			items: null,
			system: null,
			custom: node.type,
			renderer: node.renderer,
			type: ISSUE_FIELD_SINGLE_GROUP_CF_TYPE,
		},
	};
};
